// Copyright (c) StrangeBee 2024

import { FilterInput, SearchController, PossibleNamedQuery, SearchResultsType } from 'thehive-sdk';
import { ListItemsPerPageType } from '@Constants/pagination';

export interface SearchOnListParams {
    queryName: PossibleNamedQuery;
    itemsPerPage: ListItemsPerPageType;
    page: number;
    filters: FilterInput[];
    extraData?: string[];
    options?: Record<string, any>;
}

export interface SearchOnCountParams {
    queryName: PossibleNamedQuery;
    filters: FilterInput[];
    options?: Record<string, any>;
    customUrl?: string;
}

export interface SearchEventList {
    onKeyword: (query: string) => Promise<SearchResultsType[]>;
    onList: <T>(params: SearchOnListParams) => Promise<T[]>;
    onCount: (params: SearchOnCountParams) => Promise<number>;
}

interface SearchEventListParams {
    controller: SearchController;
}

export const computeEventList = ({ controller }: SearchEventListParams): SearchEventList => ({
    onList: <T>({ queryName, filters, itemsPerPage, page, extraData, options }: SearchOnListParams): Promise<T[]> => {
        return controller.list<T[]>({
            selector: {
                head: [{ name: queryName }],
                name: `search-${queryName}`,
                extraData,
                options,
            },
            sort: ['-_createdAt'],
            filters,
            paginationOptions: { itemsPerPage, page },
        });
    },
    onCount: ({ queryName, filters, options }: SearchOnCountParams): Promise<number> => {
        return controller.count({
            selector: {
                head: [{ name: queryName }],
                name: `search-${queryName}`,
                options,
            },
            filters,
        });
    },
    onKeyword: (query): Promise<SearchResultsType[]> => {
        return controller.keyword(query);
    },
});
